/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1MinusIcon16Light } from './People1MinusIcon16Light';
import { People1MinusIcon16Regular } from './People1MinusIcon16Regular';
import { People1MinusIcon16Solid } from './People1MinusIcon16Solid';
import { People1MinusIcon20Light } from './People1MinusIcon20Light';
import { People1MinusIcon20Regular } from './People1MinusIcon20Regular';
import { People1MinusIcon20Solid } from './People1MinusIcon20Solid';
import { People1MinusIcon24Regular } from './People1MinusIcon24Regular';
import { People1MinusIcon24Solid } from './People1MinusIcon24Solid';
import { People1MinusIcon32Regular } from './People1MinusIcon32Regular';
import { People1MinusIcon64Regular } from './People1MinusIcon64Regular';
var sizes = {
    16: {
        light: People1MinusIcon16Light,
        regular: People1MinusIcon16Regular,
        solid: People1MinusIcon16Solid,
    },
    20: {
        light: People1MinusIcon20Light,
        regular: People1MinusIcon20Regular,
        solid: People1MinusIcon20Solid,
    },
    24: {
        regular: People1MinusIcon24Regular,
        solid: People1MinusIcon24Solid,
    },
    32: {
        regular: People1MinusIcon32Regular,
    },
    64: {
        regular: People1MinusIcon64Regular,
    },
};
export var People1MinusIcon = forwardRef('People1MinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
